import * as React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { AccountHelperWrapper, AccountHelperLink } from './AccountHelperInfo.style';
import { observer } from 'src/utils/mobx-react';
import { TermsPage } from 'src/domains/players/webview/components/SignUp';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

interface AccountHelperInfoPropsType {
    isSaferGamblingAvailable?: boolean;
    privacyPolicy?: boolean;
    smallerPadding?: boolean;
    version?: 'primary' | 'secondary'; // Please change the name to something more specific.
}

export const AccountHelperInfo = observer(
    'AccountHelperInfo',
    ({
        version = 'primary',
        privacyPolicy = false,
        smallerPadding = false,
        isSaferGamblingAvailable = false,
    }: AccountHelperInfoPropsType) => {
        const common = useCommon();
        const appPlayersState = AppPlayersState.get(common);
        const config = ConfigComponents.get(common).config;
        const { cmsDrawerPagesState } = appPlayersState;
        const { hasNeedHelpAccountSection, accountHelperMail } = config;

        if (!hasNeedHelpAccountSection) {
            return null;
        }

        if (config.accountDrawerNew) {
            return (
                <AccountHelperWrapper smallerPadding={smallerPadding}>
                    {isSaferGamblingAvailable === true ? (
                        <AccountHelperLink
                            to={{ account: 'static', static: 'safer-gambling' }}
                            dataTest='safer-gambling'
                            version={version}
                        >
                            <I18n
                                langKey='account.safer-gambling'
                                defaultText='Safer Gambling'
                            />
                        </AccountHelperLink>
                    ) : (
                        <AccountHelperLink
                            to={{ account: 'static', static: 'help' }}
                            dataTest='help-and-faq'
                            version={version}
                        >
                            <I18n
                                langKey='account.help-and-faq'
                                defaultText="Help and FAQ's"
                            />
                        </AccountHelperLink>
                    )}

                    {isSaferGamblingAvailable === true ? (
                        <AccountHelperLink
                            to={`mailto:${accountHelperMail}`}
                            dataTest='support-mail'
                            version={version}
                        >
                            <I18n
                                langKey='account.contact'
                                defaultText='Contact'
                            />
                        </AccountHelperLink>
                    ) : (
                        <AccountHelperLink
                            to={`mailto:${accountHelperMail}`}
                            dataTest='support-mail'
                            version={version}
                        >
                            <I18n
                                langKey='account.contact-support'
                                defaultText='Contact Support'
                            />
                        </AccountHelperLink>
                    )}

                    {privacyPolicy === true ? (
                        <AccountHelperLink
                            to={{ account: 'static', static: 'privacy-policy' }}
                            dataTest='privacy-policy'
                            version={version}
                        >
                            <I18n
                                langKey='account.privacy-policy'
                                defaultText='Privacy Policy'
                            />
                        </AccountHelperLink>
                    ) : null}
                </AccountHelperWrapper>
            );
        }

        return (
            <>
                {cmsDrawerPagesState.displayPage === true &&
                (cmsDrawerPagesState.pageType === 'help' ||
                    cmsDrawerPagesState.pageType === 'privacy-policy' ||
                    cmsDrawerPagesState.pageType === 'responsible-gambling' ||
                    cmsDrawerPagesState.pageType === 'safer-gambling') &&
                cmsDrawerPagesState.title !== null &&
                cmsDrawerPagesState.content !== null ? (
                    <TermsPage
                        title={cmsDrawerPagesState.title}
                        content={cmsDrawerPagesState.content}
                        closePage={cmsDrawerPagesState.closePage}
                    />
                ) : null}
                <AccountHelperWrapper smallerPadding={smallerPadding}>
                    {isSaferGamblingAvailable === true ? (
                        <AccountHelperLink
                            onClick={cmsDrawerPagesState.showSaferGamblingPage}
                            dataTest='responsible-gambling'
                            version={version}
                        >
                            <I18n
                                langKey='account.safer-gambling'
                                defaultText='Safer Gambling'
                            />
                        </AccountHelperLink>
                    ) : (
                        <AccountHelperLink
                            onClick={cmsDrawerPagesState.showHelpPage}
                            dataTest='help-and-faq'
                            version={version}
                        >
                            <I18n
                                langKey='account.help-and-faq'
                                defaultText="Help and FAQ's"
                            />
                        </AccountHelperLink>
                    )}

                    {isSaferGamblingAvailable === true ? (
                        <AccountHelperLink
                            to={`mailto:${accountHelperMail}`}
                            dataTest='support-mail'
                            version={version}
                        >
                            <I18n
                                langKey='account.contact'
                                defaultText='Contact'
                            />
                        </AccountHelperLink>
                    ) : (
                        <AccountHelperLink
                            to={`mailto:${accountHelperMail}`}
                            dataTest='support-mail'
                            version={version}
                        >
                            <I18n
                                langKey='account.contact-support'
                                defaultText='Contact Support'
                            />
                        </AccountHelperLink>
                    )}

                    {privacyPolicy === true ? (
                        <AccountHelperLink
                            onClick={cmsDrawerPagesState.showPrivacyPolicyPage}
                            dataTest='privacy-policy'
                            version={version}
                        >
                            <I18n
                                langKey='account.privacy-policy'
                                defaultText='Privacy Policy'
                            />
                        </AccountHelperLink>
                    ) : null}
                </AccountHelperWrapper>
            </>
        );
    }
);
